import { createContext, useContext, useEffect, useState, useCallback } from "react";
import {
  play as playSound,
  setTheme as setSoundTheme,
  setMuted as setSoundMuted,
  setMasterVolume,
} from "@/lib/soundEngine";

const KEY = "trainwreck.settings.v1";
const DEFAULTS = { theme: "calm", muted: false, volume: 0.65 };

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
    } catch {
      // ignore
    }
    return DEFAULTS;
  });

  useEffect(() => {
    setSoundTheme(settings.theme);
    setSoundMuted(settings.muted);
    setMasterVolume(settings.volume);
    try {
      localStorage.setItem(KEY, JSON.stringify(settings));
    } catch {
      // ignore quota errors
    }
  }, [settings]);

  const update = useCallback((patch) => setSettings((s) => ({ ...s, ...patch })), []);

  const play = useCallback((action) => {
    playSound(action);
  }, []);

  return (
    <SettingsCtx.Provider value={{ settings, update, play }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsCtx);
  if (!ctx) throw new Error("useSettings must be used inside SettingsProvider");
  return ctx;
}
